import React from 'react';
import './Nosotros.css';

import staffOwner from '../images/staff-owner.png';

const Nosotros = () => {
  return (
    <main className="nosotros-container">

      {/* HERO */}
      <section className="nosotros-hero">

        <div className="nosotros-overlay">

          <div className="nosotros-content">

            <span className="nosotros-badge">
              NOSOTROS
            </span>

            <h1>
              Sobre <span>Nosotros</span>
            </h1>

            <p>
              Conoce a las personas que hacen posible que
              <strong> Club Oficial RP </strong>
              sea una comunidad única.
            </p>

          </div>

        </div>

      </section>

      {/* TITULO */}
      <section className="staff-section">

        <div className="staff-title">

          <span>
            NUESTRO EQUIPO
          </span>

          <h2>
            Organigrama del Staff
          </h2>

          <p>
            Un equipo comprometido con la comunidad.
          </p>

        </div>

        <div className="staff-grid">

          {/* DUEÑO */}

          <div className="staff-card owner-card">

            <div className="staff-number">
              1
            </div>

            <div className="staff-role owner-role">
              DUEÑO
            </div>

            <img
              src={staffOwner}
              alt="Dueño"
              className="staff-avatar"
            />

            <h3>
              Dueño 👑
            </h3>

            <span className="staff-badge owner-badge">
              FUNDADOR
            </span>

            <p>
              Fundador y propietario de Club Oficial RP.
            </p>

          </div>

          <div className="arrow">
            ❯
          </div>

          {/* ADMIN */}

          <div className="staff-card">

            <div className="staff-number blue">
              2
            </div>

            <div className="staff-icon">
              👑
            </div>

            <h3>
              Administrador
            </h3>

            <span className="staff-badge blue-badge">
              STAFF
            </span>

            <p>
              Encargado de la gestión general del servidor.
            </p>

          </div>

          <div className="arrow">
            ❯
          </div>

          {/* MOD */}

          <div className="staff-card">

            <div className="staff-number purple">
              3
            </div>

            <div className="staff-icon">
              🛡️
            </div>

            <h3>
              Moderador
            </h3>

            <span className="staff-badge purple-badge">
              STAFF
            </span>

            <p>
              Vela por el cumplimiento de las normas.
            </p>

          </div>

          <div className="arrow">
            ❯
          </div>

          {/* SOPORTE */}

          <div className="staff-card">

            <div className="staff-number green">
              4
            </div>

            <div className="staff-icon">
              🎧
            </div>

            <h3>
              Soporte
            </h3>

            <span className="staff-badge green-badge">
              STAFF
            </span>

            <p>
              Ayuda a los jugadores con sus consultas.
            </p>

          </div>

          <div className="arrow">
            ❯
          </div>

          {/* DEV */}

          <div className="staff-card">

            <div className="staff-number orange">
              5
            </div>

            <div className="staff-icon">
              💻
            </div>

            <h3>
              Desarrollador
            </h3>

            <span className="staff-badge orange-badge">
              STAFF
            </span>

            <p>
              Encargado del desarrollo y mejoras del servidor.
            </p>

          </div>

          <div className="arrow">
            ❯
          </div>

          {/* EVENTOS */}

          <div className="staff-card">

            <div className="staff-number pink">
              6
            </div>

            <div className="staff-icon">
              📢
            </div>

            <h3>
              Eventos
            </h3>

            <span className="staff-badge pink-badge">
              STAFF
            </span>

            <p>
              Organiza eventos y actividades para la comunidad.
            </p>

          </div>

        </div>

      </section>

      {/* MENSAJE FINAL */}

      <section className="family-box">

        <div className="family-icon">
          👥
        </div>

        <div>

          <h3>
            Más que un equipo, somos una familia.
          </h3>

          <p>
            Cada miembro trabaja día a día para ofrecer
            la mejor experiencia posible a toda la comunidad
            de <strong>Club Oficial RP</strong>.
          </p>

        </div>

      </section>

    </main>
  );
};

export default Nosotros;